export enum UserComboboxOptionType {
  USER = "user",
  TEAM = "team",
  ORG = "org",
  DIRECT_REPORTS = "directReports",
  REPORTING_TREE = "reportingTree",
}
